export const initialBlockCategoryState = {
  status: 'idle',
  error: 'init_mode',
}
